import { FeedbackPhase } from 'js/feedback/FeedbackPopover';
import { write as writeArbitraryEvent } from 'js/core_webpack/arbitrary_events';
import type { EventData } from 'js/core_webpack/arbitrary_events';
import trackClick from 'js/utils/trackClick';

export type AnalyticsFeedbackSubject = {
  experience: 'new' | 'legacy';
  view: string;
  premium: boolean;
  viewedUserId: number;
};

type AnalyticsFeedbackData = EventData['AnalyticsDashboardFeedback'];

export const analyticsFeedbackData = (
  subject: AnalyticsFeedbackSubject,
  phase: FeedbackPhase,
  rating: number | null,
  comment: string,
): AnalyticsFeedbackData => ({
  view: subject.view,
  experience: subject.experience,
  rating,
  comment: comment.length > 0 ? comment : null,
  comment_length: comment.length,
  phase,
  is_premium: subject.premium,
  viewed_user_id: subject.viewedUserId,
});

export const writeAnalyticsFeedback = (
  data: AnalyticsFeedbackData,
): ReturnType<typeof writeArbitraryEvent> =>
  writeArbitraryEvent('AnalyticsDashboardFeedback', data);

export const trackAnalyticsFeedback = (
  subject: Pick<AnalyticsFeedbackSubject, 'experience' | 'view'>,
  action: string,
  extra: Record<string, unknown>,
): void =>
  trackClick({
    source: `analytics_v2.feedback_${action}`,
    extra: { view: subject.view, experience: subject.experience, ...extra },
  });

export const alertPreviewFeedback = (
  phase: FeedbackPhase,
  data: AnalyticsFeedbackData,
): void => {
  if (phase === 'comment')
    window.alert(
      `Analytics dashboard feedback (preview only)\n${JSON.stringify(data, null, 2)}`,
    );
};
